<template>
    <router-view />
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Noto IKEA Latin', 'Noto Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Form controls don't inherit font-family by default — keep them on the brand font too. */
button,
input,
select,
textarea {
  font-family: inherit;
}
</style>
